import { useEffect, useRef, useState } from "react";

declare const bootstrap: any;

function InputCopyClipboard({ text }) {

    const tooltip = useRef(null)
    const [isCopied, setIsCopied] = useState(false)

    const copyToClipboard = () => {
        // Crear un elemento de texto temporal
        const elementoTemporal = document.createElement("textarea");
        elementoTemporal.value = text;

        // Agregar el elemento temporal al DOM
        document.body.appendChild(elementoTemporal);

        // Seleccionar el texto temporal
        elementoTemporal.select();

        // Copiar el texto seleccionado en el portapapeles
        document.execCommand("copy");

        // Remover el elemento temporal del DOM
        document.body.removeChild(elementoTemporal);

        setContentTooltip('¡Copiado!');
        setIsCopied(true);
        

        setTimeout(() => {
            setContentTooltip('Copiar al portapapeles');
            setIsCopied(false)
        }, 2000)
    }

    const setContentTooltip = (text) => {
        try {
            const tooltipInstance = bootstrap.Tooltip.getInstance(tooltip.current)
            tooltipInstance.setContent({ '.tooltip-inner': text })

        } catch (error) { }
    }

    useEffect(() => {
        new bootstrap.Tooltip(tooltip.current)
    }, [])
    

    return (
        <div className="input-group input-group-sm input-group-merge table-input-group">
            <input id="apiKeyCode1" type="text" className="form-control" readOnly value={text} />
            <button className="js-clipboard input-group-append input-group-text" data-bs-toggle="tooltip" title="Copiar al portapapeles" onClick={copyToClipboard} ref={tooltip}>
                <i className={ isCopied ? 'bi-check': 'bi-clipboard'}></i>
            </button>
        </div>
    )
}
export default InputCopyClipboard